module.exports = __webpack_public_path__ + "fa-regular-400.691aadc3c6817363ca48.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/assets/fonts/webfonts/fa-regular-400.woff
// module id = ../../../../../src/assets/fonts/webfonts/fa-regular-400.woff
// module chunks = styles